import * as api from '../Firebase/apiParcels'
import * as apiO from '../Firebase/apiOwners'
import { createTitle } from '../config/parcelDataScheme'
import jskFilter from '../utils/jskFilter'
import { SORT } from '../config/tableLayout'
import DSI from '../config/tableLayoutIndexes'
import { JOIN_MAIN_OWNER_NOTE as NOTE } from '../config/variables'
import { MASS_EDITING_OPERATION as MEO,
  REPLACE_VALUE_SEP as RVS } from '../components/MassEditingManager/toolsItems'
const PARCEL_LIST_LOADING = 'PARCEL_LIST_LOADING'
const PARCEL_LIST_RECEIVE = 'PARCEL_LIST_RECEIVE'
const PARCEL_CHB_CHANGED = 'PARCEL_CHB_CHANGED'
const PARCEL_SAVED = 'PARCEL_SAVED'
const PARCEL_DELETE = 'PARCEL_DELETE'
const PARCEL_SELECTIONS = 'PARCEL_SELECTIONS'
const OWNER_SAVED = 'OWNER_SAVED'
const OWNER_DELETED = 'OWNER_DELETED'
const OWNERS_DELETED = 'OWNERS_DELETED'
const MASS_EDITING = 'MASS_EDITING'
const JOIN_OWNER = 'JOIN_OWNER'

export const getParcelList = (id) => {
  return (dispatch, getState) => {
    dispatch(parcelListLoading())
    const parcels = getState().parcelList.parcels[id]
    if (parcels === undefined) {
      api.getParcelList(id, dispatch, parcelListReceive)
    } else {
      dispatch(parcelListReceive(id, parcels, getState().parcelList.owners[id], true))
    }
  }
}

const parcelListLoading = () => {
  return {
    type: PARCEL_LIST_LOADING
  }
}

const parcelListReceive = (id, parcels, owners, stored = false) => {
  return {
    type: PARCEL_LIST_RECEIVE,
    id: id,
    parcels: parcels,
    owners: owners,
    stored: stored
  }
}

export const saveParcel = (projectId, parcelId, parcelData, ownersDataArr) => {
  return (dispatch, getState) => {
    const count = getState().account.c + 1
    api.saveParcel(dispatch, onParcelSaved, projectId, parcelId, parcelData,
      ownersDataArr, count)
  }
}

export const onParcelSaved = (projectId, parcelId, parcelData, updatedOwners,
    addedOwners) => {
  return {
    type: PARCEL_SAVED,
    projectId: projectId,
    parcelId: parcelId,
    parcelData: parcelData,
    updatedOwners: updatedOwners,
    addedOwners: addedOwners
  }
}

export const deleteParcels = (projectId) => {
  return (dispatch, getState) => {
    if (getState().parcelList.countOfSelected[projectId].parcels === 0) {
      alert('Nejdříve vyberte parcely, které chcete smazat')
      return
    }
    const selections = getState().parcelList.selections[projectId].parcels
    let deletedPids = []
    for (let p in selections) {
      if (selections.hasOwnProperty(p)) {
        if (selections[p]) {
          deletedPids.push(p)
        }
      }
    }
    let parcels = deletedPids
    if (!window.confirm(parcels.length === 1 ? 'Smazat vybranou parcelu?'
        : 'Smazat vybrané parcely?')) {
      return
    }
    api.deleteParcels(projectId, parcels, dispatch, onParcelDelete)
  }
}

const onParcelDelete = (projectId, pids) => {
  return {
    type: PARCEL_DELETE,
    projectId: projectId,
    pids: pids
  }
}

export const onParcelChbChanged = (projectId, parcelId, sorted) => {
  return {
    type: PARCEL_CHB_CHANGED,
    projectId: projectId,
    parcelId: parcelId,
    sorted: sorted
  }
}

export const onParcelSelections = (projectId, select, sorted) => {
  return (dispatch, getState) => {
    const { hasFilter, filter } = getState().tableLayout
    dispatch(parcelSelections(projectId, select, sorted, hasFilter, filter))
  }
}

const parcelSelections = (projectId, select, sorted, hasFilter, filter) => {
  return {
    type: PARCEL_SELECTIONS,
    projectId: projectId,
    select: select,
    sorted: sorted,
    hasFilter: hasFilter,
    filter: filter
  }
}

export const saveOwner = (projectId, ownerData) => {
  return (dispatch) => {
    apiO.saveOwner(dispatch, onOwnerSaved, projectId, ownerData)
  }
}

const onOwnerSaved = (projectId, ownerId, ownerData) => {
  return {
    type: OWNER_SAVED,
    projectId: projectId,
    ownerId: ownerId,
    ownerData: ownerData
  }
}

export const deleteOwner = (projectId, ownerId, name) => {
  if (!window.confirm(`Smazat vlastníka ${name}?`)) {
    return
  }
  return (dispatch) => {
    apiO.deleteOwner(dispatch, onOwnerDeleted, projectId, ownerId)
  }
}

export const deleteOwners = (projectId, ownersIds) => {
  if (!window.confirm(`Smazat všechny vlastníky bez parcel?`)) {
    return
  }
  return (dispatch) => {
    apiO.deleteOwners(dispatch, onOwnersDeleted, projectId, ownersIds)
  }
}

const onOwnerDeleted = (projectId, ownerId) => {
  return {
    type: OWNER_DELETED,
    projectId: projectId,
    ownerId: ownerId
  }
}

const onOwnersDeleted = (projectId, ownersIds) => {
  return {
    type: OWNERS_DELETED,
    projectId: projectId,
    ownersIds: ownersIds
  }
}

const resolveSeparator = index => {
  let sep
  switch (index) {
    case DSI.TAGS:
      sep = ';'
      break
    case 'ab':
      sep = ''
      break
    case 'cn':
      sep = ''
      break
    default:
      sep = ', '
  }
  return sep
}

export const massEditing = (dataIndex, value, operation, prevOperation) => {
  return (dispatch, getState) => {
    const projectId = getState().parcelList.currentProject
    const sorted = getState().tableLayout.sorted
    const SORT_KEY = sorted === SORT.OWNER ? 'owners' : 'parcels'
    const selections = getState().parcelList.selections[projectId][SORT_KEY]
    let selectedIds = []
    for (let p in selections) {
      if (selections[p]) {
        selectedIds.push(p)
      }
    }
    const data = { ...getState().parcelList[SORT_KEY][projectId] }
    const upadatedData = {}
    
    const doOperation = (func) => {
      for (let i = 0; i < selectedIds.length; i++) {
        let d = data[selectedIds[i]][dataIndex] || ''
        let p = data[selectedIds[i]]
        const result = func(d, p, i)
        if (result || result === '') {
          upadatedData[selectedIds[i]] = result
        }
      }
    }

    const fAdd = od => {
      const sep = resolveSeparator(dataIndex)
      return od = !od ? value : `${od}${sep}${value}`
    }

    const fRewrite = () => value

    const fReplace = od => {
      const values = value.split(RVS)
      if (od.indexOf(values[1] !== -1)) {
        return od.replace(new RegExp(values[1], 'g'), values[0])
      }
    }

    const fRemove = od => {
      // tags only
      const valueArr = value.split(';')
      let da = null
      for (let i = 0; i < valueArr.length; i++) {
        const v = valueArr[i]
        if (od.indexOf(v) !== -1) {
          if (da === null) {
            da = od.split(';')
          }
          const iof = da.indexOf(v)
          da.splice(iof, 1)
        }
      }
      if (da !== null) {
        return da.join(';')
      }
      return null
    }

    const fDeleteAll = () => ''

    const fInsertArea = (od, p) => p[DSI.AREA] || 0

    let contractNo = value
    const fNumber = od => {
      return od ? od : contractNo++
    }

    const fPriceKu = (od, p) => {
      return {
        T: computePriceKu(p)
      }
    }

    const computePriceKu = p => {
      const { U, I } = value[p[DSI.CADASTRAL].trim().toUpperCase()]
      return Math.round((p[DSI.AREA] || 0) * U * I)
    }

    const fPriceBpej = (od, p) => {
      return {
        T: computePriceBpej(p)
      }
    }

    const computePriceBpej = p => {
      let t = 0
      try {
        const bpejs = p[DSI.BPEJ].split(',')
        bpejs.forEach((v, i, arr) => arr[i] = v.trim())
        const areas = p[DSI.BPEJ_AREA].split(',')
        areas.forEach((v, i, arr) => arr[i] = v.trim())
        bpejs.forEach((v, i) => {
          const { U, I } = value[v]
          t = t + areas[i] * U * I
        })
      }
      catch (err) {
        t = 0
      }
      return t ? Math.round(t) : ''
    }

    const fPriceOwn = (od, p) => {
      return {
        T: Math.round(computePriceOwn(p))
      }
    }

    const computePriceOwn = p => {
      const { M, U, OT } = value
      return M === 0 ? (p[DSI.AREA] || 0) * U : OT
    }

    const fPriceFinal = (od, p) => {
      const t = p[value]
      return {
        M: value - DSI.FIRST_PRICE + 1,
        T: t ? t.T : 0
      }
    }

    const upadatedData2 = {}
    let isUpdate2 = false

    const fUpdate = (od, p, i) => {
      const m = p[DSI.FINAL_PRICE] ? p[DSI.FINAL_PRICE].M : 'x'
      if (m === dataIndex - DSI.FIRST_PRICE + 1) {
        isUpdate2 = true
        switch (prevOperation) {
          case MEO.DELETE_ALL:
            upadatedData2[selectedIds[i]] = {
              M: 0,
              T: ''
            }
            break;
          case MEO.PRICE_KU:
            upadatedData2[selectedIds[i]] = {
              M: m,
              T: computePriceKu(p)
            }
            break
          case MEO.PRICE_BPEJ:
            upadatedData2[selectedIds[i]] = {
              M: m,
              T: computePriceBpej(p)
            }
            break
          case MEO.PRICE_OWN:
            upadatedData2[selectedIds[i]] = {
              M: m,
              T: computePriceOwn(p)
            }
            break
          default:
            break;
        }
      }
    }

    switch (operation) {
      case MEO.ADD:
        doOperation(fAdd)
        break
      case MEO.REWRITE:
        doOperation(fRewrite)
        break
      case MEO.REPLACE:
        doOperation(fReplace)
        break
      case MEO.REMOVE:
        doOperation(fRemove)
        break
      case MEO.DELETE_ALL:
        doOperation(fDeleteAll)
        break
      case MEO.INSERT_AREA:
        doOperation(fInsertArea)
        break
      case MEO.NUMBER:
        doOperation(fNumber)
        break
      case MEO.PRICE_KU:
        doOperation(fPriceKu)
        break
      case MEO.PRICE_BPEJ:
        doOperation(fPriceBpej)
        break
      case MEO.PRICE_OWN:
        doOperation(fPriceOwn)
        break
      case MEO.PRICE_T:
        doOperation(fPriceFinal)
        break
      case MEO.PRICE_T_UPDATE:
        doOperation(fUpdate)
        break
      default:
    }

    api.massEditing(dispatch, onMassEditing, projectId, SORT_KEY,
      dataIndex, upadatedData)

    if (isUpdate2) {
      api.massEditing(dispatch, onMassEditing, projectId, SORT_KEY,
        DSI.FINAL_PRICE, upadatedData2)
    }
  }
}

const onMassEditing = (projectId, sortKey, dataIndex, upadatedData) => {
  return {
    type: MASS_EDITING,
    projectId: projectId,
    sortKey: sortKey,
    dataIndex: dataIndex,
    upadatedData: upadatedData
  }
}

export const joinOwner = projectId => {
  return (dispatch, getState) => {
    if (!window.confirm('Sloučit vybrané vlastníky do jendoho? Ostatní budou nenávratně smazáni!')) {
      return
    }
    const oSelections = getState().parcelList.selections[projectId].owners
    let parcels = getState().parcelList.parcels[projectId]
    let oIds = []
    for(let p in oSelections) {
      if (oSelections[p]) {
        oIds.push(p)
        oSelections[p] = false
      }
    }
    const owners = getState().parcelList.owners[projectId]
    let firstIndex = 0
    let newNote = null
    for (let i = 0; i < oIds.length; i++) {
      const note = owners[oIds[i]].no
      if (note && note.indexOf(NOTE) !== -1 ) {
        firstIndex = i
        newNote = note.replace(NOTE, '')
        owners[oIds[i]].no = newNote
        break
      }
    }
    const first = oIds[firstIndex]
    oIds.splice(firstIndex, 1)
    let changes = {}
    for (let i = 0; i < oIds.length; i++) {
      const oid = oIds[i]
      for (let p in parcels) {
        let o = parcels[p][DSI.OWNER_NAME]
        if(o.indexOf(oid) !== -1) {
          o = o.replace(oid, first)
          parcels[p][DSI.OWNER_NAME] = o
          changes[p] = o
        }
      }
    }
    api.joinOwners(projectId, changes, oIds, first, newNote, parcels,
      dispatch, onJoinOwner)
  }
}

export const onJoinOwner = (projectId, parcels, oIds) => {
  return {
    type: JOIN_OWNER,
    projectId: projectId,
    parcels: parcels,
    ownersIds: oIds
  }
}

const initState = {
  currentProject: '',
  parcels: {},
  owners: {},
  selections: {},
  countOfSelected: {},
  titles: {},
  loading: false
}

export default (state = initState, action) => {
  let newState
  switch (action.type) {
    case PARCEL_LIST_LOADING:
      return Object.assign({}, state, {
        loading: true
      })
    case PARCEL_LIST_RECEIVE: {
      newState = Object.assign({}, state, {
        currentProject: action.id,
        parcels: {
          ...state.parcels,
          [action.id]: action.parcels
        },
        owners: {
          ...state.owners,
          [action.id]: action.owners
        },
        loading: false
      })
      if (!action.stored) {
        newState.selections[action.id] = {
          parcels: {},
          owners: {}
        }
        newState.titles[action.id] = {}
        for (let prop in action.parcels) {
          newState.selections[action.id].parcels[prop] = false
          newState.titles[action.id][prop] = createTitle(action.parcels[prop])
        }
        for (let prop in action.owners) {
          newState.selections[action.id].owners[prop] = false
        }
        newState.countOfSelected[action.id] = {
          parcels: 0,
          owners: 0
        }
      }
      return newState
    }
    case PARCEL_CHB_CHANGED: {
      const { projectId, parcelId, sorted } = action
      const SORT_KEY = sorted === SORT.OWNER ? 'owners' : 'parcels'
      const oldSelectionValue = state.selections[projectId][SORT_KEY][parcelId]
      const oldSelectionCount = state.countOfSelected[projectId][SORT_KEY]
      const increment = oldSelectionValue ? -1 : 1
      return Object.assign({}, state, {
        selections: {
          ...state.selections,
          [projectId]: {
            ...state.selections[projectId],
            [SORT_KEY]: {
              ...state.selections[projectId][SORT_KEY],
              [parcelId]: !oldSelectionValue
            }
          }
        },
        countOfSelected: {
          ...state.countOfSelected,
          [projectId]: {
            ...state.countOfSelected[projectId],
            [SORT_KEY]: oldSelectionCount + increment
          }
        }
      })
    }
    case PARCEL_SAVED: {
      let newState = Object.assign({}, state, {
        parcels: {
          ...state.parcels,
          [action.projectId]: {
            ...state.parcels[action.projectId],
            [action.parcelId]: action.parcelData
          }
        },
        titles: {
          ...state.titles,
          [action.projectId]: {
            ...state.titles[action.projectId],
            [action.parcelId]: createTitle(action.parcelData)
          }
        }
      })
      if (state.selections[action.projectId].parcels[action.parcelId]
          === undefined) {
        newState.selections[action.projectId].parcels[action.parcelId] = false
      }
      if (action.updatedOwners) {
        newState.owners[action.projectId] = {
          ...state.owners[action.projectId],
          ...action.updatedOwners
        }
      }
      if (action.addedOwners.length !== 0) {
        let addedOwnersSelection = {}
        for (let i = 0; i < action.addedOwners.length; i++) {
          addedOwnersSelection[action.addedOwners[i]] = false
        }
        newState.selections[action.projectId].owners = {
          ...newState.selections[action.projectId].owners,
          ...addedOwnersSelection
        }
      }
      return newState
    }
    case PARCEL_DELETE:
      let newParcels = Object.assign({}, state.parcels[action.projectId])
      for (let pid in action.pids) {
        delete newParcels[action.pids[pid]]
      }
      let newSelection = Object.assign({}, state.selections[action.projectId].parcels)
      for (let pid in action.pids) {
        delete newSelection[action.pids[pid]]
      }
      return Object.assign({}, state, {
        parcels: {
          ...state.parcels,
          [action.projectId]: newParcels
        },
        selections: {
          ...state.selections,
          [action.projectId]: {
            owners: state.selections[action.projectId].owners,
            parcels: newSelection
          }
        },
        countOfSelected: {
          ...state.countOfSelected,
          [action.projectId]: {
            owners: state.countOfSelected[action.projectId].owners,
            parcels: 0
          }
        }
      })
    case PARCEL_SELECTIONS: {
      let newSelection = {}
      const {projectId, sorted, select, hasFilter, filter } = action
      let SORT_KEY, baseArr, filterProp, getVal
      const getValP = value => value.split(';')
      const getValO = value => [value]
      if (sorted === SORT.OWNER ) {
        SORT_KEY = 'owners'
        baseArr = state.owners[projectId]
        filterProp = 'sn'
        getVal = getValO
      } else {
        SORT_KEY = 'parcels'
        baseArr = state.parcels[projectId]
        filterProp = DSI.TAGS
        getVal = getValP
      }
      let oldSelectionValue
      oldSelectionValue = state.selections[projectId][SORT_KEY]
      let count = 0
      if (select) {
        for (let p in oldSelectionValue) {
          if (hasFilter) {
            if (jskFilter(getVal(baseArr[p][filterProp] || ''), filter)) {
              newSelection[p] = true
              count++
            } else {
              newSelection[p] = false
            }
          } else {
            newSelection[p] = true
            count++
          }
        }
      } else {
        for (let p in oldSelectionValue) {
          newSelection[p] = false
        }
      }
      return Object.assign({}, state, {
        selections: {
          ...state.selections,
          [projectId]: {
            ...state.selections[projectId],
            [SORT_KEY]: {...newSelection}
          }
        },
        countOfSelected: {
          ...state.countOfSelected,
          [projectId]: {
            ...state.countOfSelected[projectId],
            [SORT_KEY]: count
          }
        }
      })
    }
    case OWNER_SAVED:
      return Object.assign({}, state, {
        owners: {
          ...state.owners,
          [action.projectId]: {
            ...state.owners[action.projectId],
            [action.ownerId]: action.ownerData
          }
        }
      })
    case OWNER_DELETED:
      let projectOwners = Object.assign({}, state.owners[action.projectId])
      delete projectOwners[action.ownerId]
      return Object.assign({}, state, {
        owners: {
          ...state.owners,
          [action.projectId]: projectOwners
        }
      })
    case OWNERS_DELETED:
      let tempOwners = deleteOIds(Object.assign({}, state.owners[action.projectId]),
        action.ownersIds)
      return Object.assign({}, state, {
        owners: {
          ...state.owners,
          [action.projectId]: tempOwners
        }
      })
    case MASS_EDITING: {
      const { projectId, sortKey, dataIndex, upadatedData } = action
      let newState = Object.assign({}, state)
      for (let p in upadatedData) {
        newState[sortKey][projectId][p][dataIndex] = upadatedData[p]
      }
      return newState
    }
    case JOIN_OWNER:
      tempOwners = deleteOIds(Object.assign({}, state.owners[action.projectId]),
        action.ownersIds)
      return Object.assign({}, state, {
        parcels: {
          ...state.parcels,
          [action.projectId]: action.parcels
        },
        owners: {
          ...state.owners,
          [action.projectId]: tempOwners
        }
      })
    default:
      return state
  }
}

const deleteOIds = (owners, oIds) => {
  for (var i = 0; i < oIds.length; i++) {
    delete owners[oIds[i]]
  }
  return owners
}



// WEBPACK FOOTER //
// ./src/reducers/parcelList.js